import { VIVACE_HOSTNAME, VIVACE_INT_HOSTNAME, LOCAL_HOSTNAME, BCT_LOCAL_HOSTNAME, EXP_HOSTNAME, UI_HOSTNAME, UI_DEV_HOSTNAME, UI_AZURE_STAGING_HOSTNAME, UI_AZURE_HOSTNAME, UI_AZURE_DEV_HOSTNAME } from "@ane/core/lib/host/Host.constants";
import { AZURE_TEST_WORKSPACE_ID } from "@ane/core/lib/services/EnvironmentService";
import { AZURE_EXP_WIKI } from "@ane/exp-data/lib/constants/LinkConstants";
const NO_WORKSPACE_MESSAGE = `This subscription does not contain any Experimentation workspaces. To resolve this issue, select another subscription or create a workspace for this Azure subscription. For instructions see <a href="${AZURE_EXP_WIKI}" target="_blank">${AZURE_EXP_WIKI}</a> or contact your admin for assistance.`;
const NO_GROUP_MESSAGE = `This workspace does not contain any Experimentation groups. Ask your admin for help or follow the doc <a href="https://expdocs.azurewebsites.net/" target="_blank">https://expdocs.azurewebsites.net/</a> to create a group in workspace`;
const ALLOW_HOST = [
  VIVACE_HOSTNAME,
  VIVACE_INT_HOSTNAME,
  LOCAL_HOSTNAME,
  BCT_LOCAL_HOSTNAME,
  EXP_HOSTNAME,
  UI_HOSTNAME,
  UI_DEV_HOSTNAME,
  UI_AZURE_STAGING_HOSTNAME,
  UI_AZURE_HOSTNAME,
  UI_AZURE_DEV_HOSTNAME
];
const VALID_SUBSCRIPTIONS = [
  // Valid Control tower subscriptions
  "0aa912c3-3894-4efa-b17f-ee204a32c8de",
  "0a248f83-34b8-4a8f-9aec-66a1e2fd0cfc",
  "da133bcf-5c03-4465-acff-bfdc5b876ad5",
  "b4a50530-23b2-4815-a28d-ca33051dc9a5",
  "dad45786-32e5-4ef3-b90e-8e0838fbadb6",
  "37626bff-a6a4-43c2-afb0-807b4d7a5efd",
  "89c61d76-b520-415a-9a63-d8ef08df37f6",
  "75fb6ca9-d840-41ed-b4ac-e69dcc2b2f6b",
  "3de60f31-bf56-44d3-8e2f-1a6f4608240d",
  "80d2c6c6-fa64-4ab1-8aa5-4e118c6b16ce",
  // Valid Studio Subscriptions
  "0a248f83-34b8-4a8f-9aec-66a1e2fd0cfc",
  "dad45786-32e5-4ef3-b90e-8e0838fbadb6",
  "4c4ac2fa-ec19-47e5-bade-6259f2b5d900"
];
const STUDIO_WORKSPACES = [
  "d69f64f9-46ca-410d-ac25-06a727a0b7e1",
  AZURE_TEST_WORKSPACE_ID,
  "45571c2b-8dbc-4284-8677-6d5396af8db0"
];
const VALID_WORKSPACES = [
  // Valid Control tower Subscriptions
  "37960930-97d4-4ef6-8335-0256d3c8194f",
  "b78ecb47-a89e-4f38-b6f3-02f7b0d93eff",
  "06826667-e902-409d-9cf7-03b21f2aca1c",
  "52f612ad-3920-4622-b9e9-049d679a778a",
  "dff8488f-3196-4ec9-a74d-04f1dba2a241",
  "4d59744c-c847-4ad4-94e0-067c86364c01",
  "3e57ffb8-8d3c-4bc4-8c6f-082105d39984",
  "9b07feb9-6ab6-41d2-9095-0a3e9ca0f860",
  "0c31c27b-327e-4394-a063-0b20e996d666",
  "399df5dc-a877-4176-b9eb-0b36831c8c1e",
  "96b51d23-051e-4cd5-a19e-0b9466522f13",
  "84eef170-6189-4197-a3f3-0c585569e2a1",
  "3420bf79-70f4-4308-9de2-0d6ce286a656",
  "84f25acb-2fb7-420e-98ca-0ed03816e0af",
  "44d39b6b-f914-462a-b4b4-0f2b8c699f89",
  "567751f4-29f4-4e78-a6d8-115fb5700579",
  "2c12a740-e806-479b-bfb6-14b77df6e725",
  "cfc1cb9c-a0a8-47b8-a984-199bfe8b3a3f",
  "ab787466-ec1e-4083-97fa-1bed30642c19",
  "e9af2c16-e4ad-45fc-a491-1d59369da961",
  "d55bcc25-6198-4837-ba21-1d62a02f10fc",
  "a17076a8-72cd-4e37-b7bb-1dc40a079012",
  "1405a5c1-dbda-47c7-a8f0-24c3ea0ed0ac",
  "45336334-7da4-4971-9c52-24cb80f53f3a",
  "8d92ffe0-cb56-4d11-98c2-26336baf0188",
  "a4479c19-64e0-41e7-815a-2643d18251d3",
  "845e6df7-8f0d-4c5d-8857-26c8fc183ff1",
  "f86351c3-458d-4fec-80e4-272c60564285",
  "5b3e48a8-0f71-4059-8312-276202b92a2f",
  "b780c73b-6c74-4cbb-9e87-28e431614e54",
  "555450ba-49b2-4d39-abcc-2954579a5f55",
  "f0fd12f3-d6db-45e7-ba09-2996045c3f0d",
  "69d75e0d-ce57-4710-b55d-29dd8d692057",
  "529bd50f-6b89-4fb1-a8da-2a155762fead",
  "d5650321-11e1-4a75-bc08-2af251395bed",
  "95c99919-3b13-41b5-8d42-2b6d6ca4e891",
  "525f0520-d216-438c-b249-2eb233407a05",
  "b094af14-04b9-4865-95c8-34478bbf1bae",
  "374298b5-4305-4129-911e-349338f437da",
  "f2402c3f-f2ae-441a-bf22-357b2bb5fd4b",
  "9d31a4e0-806e-44d4-bf0a-35cdd61f9bce",
  "da1eeb20-bd1d-4b0b-9d1c-364c552f2266",
  "10af6867-f403-41f3-95a9-3672769764b1",
  "53338caa-f87d-4dd4-9f50-3a1ed761ae43",
  "6e491554-f5c4-4604-b608-3aed23375204",
  "c046c00a-f9cc-4ee9-bffa-3b4e764b2621",
  "96b21824-f068-4639-8001-3b70781c1454",
  "ce3fdba9-2623-499b-b653-3c4107d8d5b5",
  "ed6c0708-bb0f-42ed-8f80-3ea15c3fffe1",
  "899ed38c-b179-4ee7-b94f-3f59d295463f",
  "a69eee7f-5f3b-4dad-b5ae-3f88bd4ef9b8",
  "461b2b08-769a-4088-9baf-401bd7a86d19",
  "6f6ce475-80b3-4ab5-9d02-41edeb413427",
  "4628c891-9233-4330-bd59-42ed033ebd9d",
  "951268e7-bcd4-43c5-9790-43bbfb96650e",
  "d5dc35a3-1140-4686-ac48-43ca7f156765",
  "bf2a388f-bcfe-4a13-ae55-4af66e494f2b",
  "70f37b9e-0ebd-486d-91d8-4bc20a053946",
  "22066d2c-a657-4135-80cc-4d9907fe28cc",
  "89fa2d8d-a2a4-4fa1-9d2a-4dbd07977ce3",
  "89723934-02ca-4d27-85ad-54e1cd209afe",
  "a4b8574e-f5c5-42de-890e-556aa818dfef",
  "37646a41-e3cc-43bc-83c3-55fe8044e2f0",
  "5497e497-8fcb-4e38-b498-56fb0cc359d5",
  "872d18e3-354d-4de8-99ea-5af3521bf425",
  "71b806c3-bb24-444c-a62a-5cb4af8e0acc",
  "fa18eb11-69a0-4f1a-9f36-62ee4f01fbd7",
  "d2f7cdfd-23a8-45c2-b3c3-641790683a7b",
  "a5766fee-9478-488b-9fc0-64d1ad72c290",
  "dd8ed4d1-ec95-401a-89eb-652856092830",
  "58f319e3-4c54-426b-90d0-69ad709d86c1",
  "84e95344-e974-4a0e-8e9b-6a2ac3871a76",
  "abd5131c-1fdf-4b66-b2bb-6b1dd418dd2d",
  "6df5d960-26de-4fdc-b680-6b4ff0c5047f",
  "0ae29489-e88d-4100-bf1f-6b9fbd913274",
  "1f7f3719-6add-4b1a-b4ab-6d935b50c524",
  "0dc3276e-b69e-4c39-a61a-6eda7b50fdbb",
  "7dba43d1-a1df-4736-a3b2-70e45da22edd",
  "913169a7-c75e-4199-8c53-719c8d592273",
  "744ba3fd-50ec-4cc4-b1ce-75e30236891e",
  "4181b171-2974-4a71-9706-775f8fb9008d",
  "98cdede3-f3c3-4680-a607-795e2f004c44",
  "6f3726e5-0b89-463d-9dde-796a672d757b",
  "9d5202e6-6c8c-4ffd-8263-7a324323d4d0",
  "6de755e5-f65a-4537-989d-7ab9a7348d10",
  "ba53738c-3acf-4f5e-aab8-7b9e2e7fadcd",
  "60c13e54-ea06-4358-b755-7d2e450afcbd",
  "44ff5830-351c-42a6-bae0-7d6c3e20c945",
  "1ce770e4-164b-4381-9498-8041b5290f84",
  "6153929f-8858-48fd-874c-8080ed6d7cac",
  "6b06edd6-e561-4c48-8386-811a1d48f61e",
  "41ec2a43-0f43-4409-83dd-81bd988e2215",
  "979771bb-0462-4c02-acf6-82c084f7f6d4",
  "d4f2ddf0-63eb-4798-a9c0-8558a1b40a45",
  "1a41841c-0ad2-42af-afdd-88fc3261f899",
  "22881dcf-e906-470d-bdd4-8bb8e15fab74",
  "a9d7d78b-f91c-459a-bcad-8d527d68e5a5",
  "b03fd831-03a8-439a-984e-9061ea483cc4",
  "ed1af057-5c94-424f-a189-94eb0c9b2513",
  "eb90bdd4-db77-4f40-8562-964989188c7e",
  "f4770f76-e3c3-4057-9ed3-96b9f8fc244c",
  "c4a53ce6-e76d-46d7-96a3-98e5b50044f1",
  "d873ee5c-e63e-4433-af02-98e640066b60",
  "dba61ed4-278a-4e88-b7ba-991c32308b27",
  "25b355c8-7802-4d36-97ed-9a531bcbac78",
  "75e91881-b599-4c68-9604-9a9505f84519",
  "e631b790-610e-458f-80eb-9dd292b8835c",
  "6746e651-a970-406d-bcb8-a2ad3c246f8b",
  "e9197ee8-698b-40b7-b9ad-a50ad44eae2b",
  "aa6bd2c8-1391-41b7-8444-a61e42d33094",
  "12234050-3055-41f2-9110-a7fb5bdc7591",
  "a4241071-ac16-4d3e-8ae6-ac21a695d271",
  "561cb477-76ab-4b6f-8fe9-ac4fe5ff0d04",
  "a43ed162-1cce-4005-bf55-aca7dde484ac",
  "ca2ebfed-f0bc-4dd9-962d-aee02bb92700",
  "fba0e3e6-4f15-492b-b8f3-aef2b4178421",
  "6d209aa1-6e73-47c0-8275-afc4422292e4",
  "ce3fa0a6-1a56-4899-bc90-b179e1343cd9",
  "41be17a1-fe81-47d9-86f5-b366e13a356e",
  "2a064bf0-b9cc-4a4e-bbad-b51c24fd6aca",
  "5860c04c-f73c-4393-84f6-b6aed79d4aa5",
  "bcdd3c90-e013-48c8-8341-b8a826428974",
  "61490047-3254-4ea3-8b80-be7318f9061e",
  "1c80cd22-7bcf-4734-8adf-be919719aa2d",
  "aad2cb52-cb69-49c4-bfc5-c245b0a44f43",
  "8368c447-d814-48f8-a6e5-c567b41fb696",
  "e006645d-2ef2-42c9-88df-c6f1dc45a1b8",
  "0653e64b-5872-4517-89a7-c792e24ee974",
  "8ddb615c-528f-4da4-875c-c7ce7a2e7a64",
  "93bfe15b-0ad4-4133-9bd7-c7ec3eb47bae",
  "bdb4d952-81d9-4337-bd91-c9991aefed64",
  "642335d9-93a2-4cef-8ba2-cac36f7b41b2",
  "f86f9bb6-ae8f-4082-a8ae-cb7c4d7f7023",
  "b095c2f8-ad9c-438c-919b-cef55573570c",
  "768c65c2-53ad-48cb-b2a2-d01512a56b98",
  "6d9daa12-ffc4-41dd-a52c-d0f06cb53843",
  "3f8f813c-1868-44d1-90d9-d2fe48090066",
  "ccc31296-8a66-4e3c-aaf5-d3750a109383",
  "d90ba3bb-42dd-4b3d-b557-d7d6397b197d",
  "c075a500-4d6f-4c5c-8217-dc41c0e04449",
  "4973a3f6-f498-4de8-86b8-dca7c3b4c552",
  "e322519b-8781-49ef-92f5-e0c00ec48e3e",
  "79bbb319-b944-409d-9a6e-e0df2451eccb",
  "7ed243c7-5b2f-4049-a2a2-e226f43d49dc",
  "7cfc8d63-db41-4fed-b10c-e3070fd47525",
  "b95e8e37-bd52-4a5f-a4de-e30bf6cc1d0a",
  "fac12347-9cb6-41d1-a613-e622e8513f56",
  "f6db1c18-d60f-430a-9e5c-e7c214b6aa66",
  "d9d86611-2a6f-4146-a698-eac553d99282",
  "ccc2c39c-80c5-48ae-8e65-ec15eb89470a",
  "22c4cb72-e327-4ab9-9b3e-ec5329ca72e1",
  "f454f2b9-8d2e-4d2c-9b2b-eedef66ba150",
  "7c38b290-60b2-454a-b696-f0747d014675",
  "3b0b7860-f070-4503-8c10-f16356b2e29e",
  "b6708186-0a4d-4ce1-9dd8-f198015210da",
  "b731f601-f0ec-4ead-9db8-f1990ab30b16",
  "0dae3bbe-d53b-4632-88f9-f2b25038f957",
  "01f72f3b-368e-497b-847d-f2f0bc761d85",
  "bc811c17-5987-456e-81fa-f37a4a707ddc",
  "4a8f03ab-eab0-44bb-83a6-f40c1e54d040",
  "61a46aad-4af4-426d-a238-f4b556b2f723",
  "adfd9f26-ab91-49de-95ce-f6f79a9ac6d5",
  "42cf23b8-6f15-4911-b6cb-f8624bf728ac",
  "b74783a5-52ba-4527-8c6f-f9d2db920cb5",
  "bb9a27bd-6acf-4b61-a77a-fb20b2d38c6b",
  ...STUDIO_WORKSPACES
];
export {
  ALLOW_HOST,
  NO_GROUP_MESSAGE,
  NO_WORKSPACE_MESSAGE,
  STUDIO_WORKSPACES,
  VALID_SUBSCRIPTIONS,
  VALID_WORKSPACES
};
//# sourceMappingURL=WorkspaceSelector.constants.js.map
